// redux/reducers/businessExpenseReducer.js
import {
    FETCH_EXPENSES_REQUEST,
    FETCH_EXPENSES_SUCCESS,
    FETCH_EXPENSES_FAILURE,
    FETCH_EXPENSE_SUMMARY_REQUEST,
    FETCH_EXPENSE_SUMMARY_SUCCESS,
    FETCH_EXPENSE_SUMMARY_FAILURE,
    CREATE_EXPENSE_REQUEST,
    CREATE_EXPENSE_SUCCESS,
    CREATE_EXPENSE_FAILURE,
    UPDATE_EXPENSE_REQUEST,
    UPDATE_EXPENSE_SUCCESS,
    UPDATE_EXPENSE_FAILURE,
    DELETE_EXPENSE_REQUEST,
    DELETE_EXPENSE_SUCCESS,
    DELETE_EXPENSE_FAILURE,
    SET_EXPENSE_FILTER,
    RESET_EXPENSE_FILTER
  } from '../actions/businessExpenseActions';
  
  const initialState = {
    expenses: [],
    summary: {
      totalExpense: 0,
      expensesByCategory: []
    },
    totalCount: 0,
    currentPage: 1,
    totalPages: 1,
    filters: {
      startDate: '',
      endDate: '',
      search: '',
      page: 1,
      limit: 50,
      sortBy: 'fecha',
      sortOrder: 'DESC'
    },
    loading: false,
    error: null,
    success: false
  };
  
  const businessExpenseReducer = (state = initialState, action) => {
    switch (action.type) {
      // Obtener gastos
      case FETCH_EXPENSES_REQUEST:
        return {
          ...state,
          loading: true,
          error: null
        };
      
      case FETCH_EXPENSES_SUCCESS:
        return {
          ...state,
          expenses: action.payload.data,
          totalCount: action.payload.count,
          currentPage: action.payload.currentPage,
          totalPages: action.payload.totalPages,
          loading: false,
          error: null
        };
      
      case FETCH_EXPENSES_FAILURE:
        return {
          ...state,
          loading: false,
          error: action.payload
        };
      
      // Obtener resumen de gastos
      case FETCH_EXPENSE_SUMMARY_REQUEST:
        return {
          ...state,
          loading: true,
          error: null
        };
      
      case FETCH_EXPENSE_SUMMARY_SUCCESS:
        return {
          ...state,
          summary: action.payload,
          loading: false,
          error: null
        };
      
      case FETCH_EXPENSE_SUMMARY_FAILURE:
        return {
          ...state,
          loading: false,
          error: action.payload
        };
      
      // Crear gasto
      case CREATE_EXPENSE_REQUEST:
        return {
          ...state,
          loading: true,
          error: null,
          success: false
        };
      
      case CREATE_EXPENSE_SUCCESS:
        return {
          ...state,
          expenses: [action.payload, ...state.expenses],
          loading: false,
          error: null,
          success: true
        };
      
      case CREATE_EXPENSE_FAILURE:
        return {
          ...state,
          loading: false,
          error: action.payload,
          success: false
        };
      
      // Actualizar gasto
      case UPDATE_EXPENSE_REQUEST:
        return {
          ...state,
          loading: true,
          error: null,
          success: false
        };
      
      case UPDATE_EXPENSE_SUCCESS:
        return {
          ...state,
          expenses: state.expenses.map(expense => 
            expense.id === action.payload.id ? action.payload : expense
          ),
          loading: false,
          error: null,
          success: true
        };
      
      case UPDATE_EXPENSE_FAILURE:
        return {
          ...state,
          loading: false,
          error: action.payload,
          success: false
        };
      
      // Eliminar gasto
      case DELETE_EXPENSE_REQUEST:
        return {
          ...state,
          loading: true,
          error: null,
          success: false
        };
      
      case DELETE_EXPENSE_SUCCESS:
        return {
          ...state,
          expenses: state.expenses.filter(expense => expense.id !== action.payload),
          loading: false,
          error: null,
          success: true
        };
      
      case DELETE_EXPENSE_FAILURE:
        return {
          ...state,
          loading: false,
          error: action.payload,
          success: false
        };
      
      // Filtros
      case SET_EXPENSE_FILTER:
        return {
          ...state,
          filters: {
            ...state.filters,
            ...action.payload
          }
        };
      
      case RESET_EXPENSE_FILTER:
        return {
          ...state,
          filters: initialState.filters
        };
      
      default:
        return state;
    }
  };
  
  export default businessExpenseReducer;